import { Box, TextField, Typography, Link } from '@mui/material';
import React from 'react';

const colors = { background: 'white', primary: '#345784', text: 'black' };

export default function Field({
  disabled = false,
  helpLinkOnClick = () => {},
  helperLinkText,
  label,
  maxLength,
  onChange,
  textAlign = 'left',
  type,
  value,
}) {
  return (
    <Box sx={{ width: 428, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          mb: '8px',
          px: '20px',
        }}
      >
        <Typography sx={{ fontSize: '14px', color: colors.text }}>
          {label} <span style={{ color: 'red' }}>*</span>
        </Typography>
        {!!helperLinkText && (
          <Link
            component="button"
            type="button"
            onClick={helpLinkOnClick}
            sx={{
              color: colors.primary,
              textDecoration: 'underline',
              fontSize: '12px',
            }}
          >
            {helperLinkText}
          </Link>
        )}
      </Box>
      <TextField
        type={type}
        value={value}
        onChange={onChange}
        required
        fullWidth
        disabled={disabled}
        variant="standard"
        {...(maxLength ? { inputProps: { maxLength } } : {})}
        sx={{
          fontSize: '17px',
          textAlign,
          '& .MuiInputBase-input': {
            textAlign: `${textAlign} !important`,
            color: colors.text,
            fontSize: '17px',
            minHeight: '36px',
            padding: '0px 0px 0px 20px',
            border: 'none',
            outline: 'none',
          },
          '& .MuiInput-underline:before': { borderBottom: '1px solid lightgrey' },
          '& .MuiInput-underline:after': { borderBottom: '1px solid lightgrey' },
          '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
            borderBottom: '1px solid lightgrey',
          },
        }}
      />
    </Box>
  );
}
